const styles = theme => ({
  cardWrapper: {
    maxWidth: '600px',
    width: '90vw',
    margin: '15px 20px'
  },
  headerBox: {},
  footerBox: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    alignContent: 'space-between',
    justifyContent: 'space-between',
    padding: '10px 10px 14px 15px'
  },
  button: {
    // padding: '0px 30px',

    color: 'rgba(100,100,100,1)'
  },
  footerBoxText: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    padding: '0px',
    margin: '0px'
  },
  name: {
    padding: '0px',
    margin: '0px'
  },
  address: {
    padding: '0px',
    margin: '0px'
  }
})

export default styles
